import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../store/global';
import { listCapsulas, sendCapsulaWhatsapp, capsulaTitle } from '../lib/capsulas';
import SectionBanner from '../components/SectionBanner';

/**
 * Capsulas — archivo historico de capsulas economicas (FlowexPay x Progresion).
 * Visual: .capsulas-ola + tokens --fx-* (glass Ola A). Solo chrome.
 */
export default function Capsulas() {
  const snap = useSnapshot(state);
  const userPhone = snap.user?.phonenumber
    ? `${snap.user.phonenumber.nationality?.area_code || ''}${snap.user.phonenumber.number || ''}`
    : '';
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingSlug, setSendingSlug] = useState(null);
  const [msg, setMsg] = useState(null); // { slug, ok, text }

  useEffect(() => {
    let alive = true;
    listCapsulas()
      .then((c) => alive && setItems(c))
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  const handleWhatsapp = async (slug) => {
    if (!userPhone) { setMsg({ slug, ok: false, text: 'No tienes un teléfono registrado en tu perfil.' }); return; }
    setSendingSlug(slug);
    setMsg(null);
    try {
      await sendCapsulaWhatsapp(userPhone, slug);
      setMsg({ slug, ok: true, text: 'Listo, te la enviamos a tu WhatsApp.' });
    } catch (e) {
      setMsg({ slug, ok: false, text: e.response?.data?.message || 'No pudimos enviarla. Intenta de nuevo.' });
    } finally {
      setSendingSlug(null);
      setTimeout(() => setMsg(null), 6000);
    }
  };

  return (
    <div className="capsulas-ola">
      <header className="capsulas-ola__head">
        <h1 className="capsulas-ola__title">Cápsulas</h1>
        <p className="capsulas-ola__sub">
          La economía explicada para tu plata, en audios de 3 minutos. Con información de Progresión.
        </p>
      </header>

      <SectionBanner
        id="capsulas"
        title="Escúchalas cuando quieras"
        text="Cada cápsula resume las noticias económicas y qué significan para tu bolsillo. Dale play aquí, o pídela a tu WhatsApp."
      />

      {loading ? (
        <div className="capsulas-ola__muted">Cargando cápsulas...</div>
      ) : items.length === 0 ? (
        <div className="capsulas-ola__card capsulas-ola__empty">
          <div className="capsulas-ola__empty-title">Aún no hay cápsulas</div>
          <p className="capsulas-ola__muted">Muy pronto vas a encontrar aquí tu panorama económico en audio.</p>
        </div>
      ) : (
        <div className="capsulas-ola__list">
          {items.map((c) => (
            <div key={c.slug + c.createdAt} className="capsulas-ola__card">
              <span className="capsulas-ola__accent" aria-hidden="true" />
              <div className="capsulas-ola__body">
                <div className="capsulas-ola__card-title">{capsulaTitle(c)}</div>
                <audio controls preload="none" src={c.audioUrl} className="capsulas-ola__audio" />
                <button
                  type="button"
                  onClick={() => handleWhatsapp(c.slug)}
                  disabled={sendingSlug === c.slug}
                  className="capsulas-ola__wa"
                >
                  <svg className="capsulas-ola__wa-ico" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.978-1.207zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
                  {sendingSlug === c.slug ? 'Enviando...' : 'Enviar a mi WhatsApp'}
                </button>
                {msg && msg.slug === c.slug && (
                  <div className={`capsulas-ola__msg${msg.ok ? ' is-ok' : ' is-bad'}`}>{msg.text}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
